import { getNozzleDirectionOptions, getNozzleTypes, nozzleTypeToText, toNozzleDirectionText } from "@/common/filter"
import { Equipment } from "@/services/project/equipment/equipment.model"
import { Button, Input, InputNumber, Select, Space, Table } from "antd"
import { useMemo, useState } from "react"
import styles from "./index.module.less";
import classNames from "classnames"
import { NozzleDirection, NozzleType } from "@/types/common"
import { render } from "@testing-library/react"

interface NozzleEdgesProps {
  value?: Equipment.NozzleEdge[]
  onChange?: (value: Equipment.NozzleEdge[]) => void
  disabled?: boolean
}

export const NozzleEdges = (props: NozzleEdgesProps) => {
  const { value = [], onChange, disabled } = props;
  const [record, setRecord] = useState<Equipment.NozzleEdge>();

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Simulator Code',
      dataIndex: 'simCode',
      key: 'simCode',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        return nozzleTypeToText(type)
      }
    },
    {
      title: 'Start',
      dataIndex: 'start',
      key: 'start',
      render: (start) => {
        return `(${start.x}, ${start.y})`
      }
    },
    {
      title: 'End',
      dataIndex: 'end',
      key: 'end',
      render: (end) => {
        return `(${end.x}, ${end.y})`
      }
    },
    {
      title: 'Direction',
      dataIndex: 'direction',
      key: 'direction',
      render: (direction) => toNozzleDirectionText(direction)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (val, current) => {
        return <Space><Button onClick={() => {
          const newVal = value.filter(item => item !== val)
          onChange?.(newVal)
        }}>Delete</Button></Space>
      }
    },
  ]

  const records = useMemo(() => {
    if (!value || value.length === 0) return null;
    return <Table
      bordered
      columns={columns}
      dataSource={value}
      className="table"
      rowKey='name'
      size="small"
      pagination={false}
    />
  }, [value, disabled])

  const setName = (name) => {
    if (!record) {
      setRecord({name} as any)
      return;
    }
    setRecord({...record, name})
  }

  const setStart = (attr: 'x' | 'y', val: number) => {
    if (!record) {
      setRecord({start: {[attr]: val}} as any)
      return;
    }
    setRecord({...record, start: {...record.start, [attr]: val}})
  }

  const setEnd = (attr: 'x' | 'y', val: number) => {
    if (!record) {
      setRecord({end: {[attr]: val}} as any)
      return;
    }
    setRecord({...record, end: {...record.end, [attr]: val}})
  }

  const setDirection = (val: NozzleDirection) => {
    if (!record) {
      setRecord({direction: val} as any)
      return;
    }
    setRecord({...record, direction: val})
  }

  const setCode= (val: string) => {
    if (!record) {
      setRecord({simCode: val} as any)
      return;
    }
    setRecord({...record, simCode: val})
  }

  const setType= (val: NozzleType) => {
    if (!record) {
      setRecord({type: val} as any)
      return;
    }
    setRecord({...record, type: val as any})
  }

  const addRecord = () => {
    if (!record) return;
    record.direction = record.direction || 0;
    onChange?.([...value, record]);
    setRecord({} as any)
  }

  return <div>
    {records}
    <Space align="baseline">
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Name:</div>
        <Input className={classNames(styles.pointVal, styles.w200)} value={record?.name} onChange={(e) => setName(e.target.value)}/>
      </div>
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Code:</div>
        <Input className={classNames(styles.pointVal, styles.w200)} value={record?.simCode} onChange={(e) => setCode(e.target.value)}/>
      </div>
      
    </Space>
    <Space align="baseline">
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Start:</div>
        <InputNumber
          addonBefore="x"
          className={styles.pointVal}
          controls={false}
          value={record?.start?.x}
          onChange={val => setStart('x', val || 0)}
        />
        <InputNumber
          addonBefore="y"
          className={styles.pointVal}
          controls={false}
          value={record?.start?.y}
          onChange={val => setStart('y', val || 0)}
        />
      </div>
      <div className={classNames('flex-start', 'mt-2', styles.pointEditor)}>
        <div>End:</div>
        <InputNumber addonBefore="x"
          className={styles.pointVal}
          controls={false}
          value={record?.end?.x}
          onChange={val => setEnd('x', val || 0)}
        />
        <InputNumber
          addonBefore="y"
          className={styles.pointVal}
          controls={false}
          value={record?.end?.y}
          onChange={val => setEnd('y', val || 0)}
        />
      </div>
      
    </Space>
    <Space align="baseline">
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Direction:</div>
        <Select
          options={getNozzleDirectionOptions()}
          defaultValue={0}
          className={classNames(styles.pointVal, styles.w200)}
          onChange={val => setDirection(val)}
        />
      </div>
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Type:</div>
        <Select value={record?.type} options={getNozzleTypes()} onChange={(val) => setType(val)} className={classNames(styles.pointVal, styles.w200)}/>
      </div>
      <Button onClick={() => addRecord()}>Add</Button>
    </Space>
    
  </div>
}